import { installmentIsDue } from "./installments";
import { pendingBreakdown } from "./pending";
import type { Movement } from "./types";

/** Etiquetas derivadas: tener reserva no significa haber pagado al banco. */
export function cardMovementStatus(movement: Movement, today: string): string {
  if (movement.cardPaymentStatus === "paid" || movement.historicalSettlement) return "Pagado al banco";
  if (!installmentIsDue(movement, today)) return "Corte futuro";
  const pending = pendingBreakdown(movement);
  if (pending.ownPendingCents > 0) return "Por apartar";
  if (pending.reimbursementPendingCents > 0) return "Reembolso por recibir";
  return "Dinero apartado";
}
